import {
  Component, OnInit, Input, EventEmitter, Output, ElementRef,
  TemplateRef, ViewChild, SimpleChanges, OnChanges, AfterViewInit
} from '@angular/core';
import cytoscape from 'cytoscape';
import contextMenus from 'cytoscape-context-menus';
import popper from 'cytoscape-popper';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ColorService } from './services/color.service';
import { ToolbarService } from './services/toolbar.service';
import { NodeService } from './services/node.service';
import { MutualService } from './services/mutual.service';
import { EdgehandlesService } from './services/edgehandles.service';
import { PanzoomService } from './services/panzoom.service';
import $ from 'jquery';
import { setTheme } from 'ngx-bootstrap/utils';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import edgehandles from 'cytoscape-edgehandles';
import pixelWidth from 'string-pixel-width';
import panzoom from 'cytoscape-panzoom';
import noOverlap from 'cytoscape-no-overlap';
import * as cloneDeep from 'lodash/cloneDeep';

const copy = cloneDeep;

setTheme('bs4');
cytoscape.use(popper);
cytoscape.use(contextMenus, $);
cytoscape.use(noOverlap);
cytoscape.use(edgehandles);
cytoscape.use(panzoom, $);




@Component({
  selector: 'lib-mindmap',
  templateUrl: './mindmap.component.html',
  styleUrls: ['./mindmap.component.scss']
})
export class MindmapComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() nodeAttach: any = null;
  @Input() colorBackground: String;
  @Input() data: Object;

  @Output() onChange = new EventEmitter<any>();
  @Output() onSubmited = new EventEmitter<any>();
  @Output() onUpdate = new EventEmitter<any>();
  @Output() onCreate = new EventEmitter<any>();
  @Output() onDelete = new EventEmitter<any>();
  @Output() onSelectNodeAttached = new EventEmitter<any>();
  @Output() onSelectIdNode = new EventEmitter<any>();
  @Output() onCancelModal = new EventEmitter<any>();
  @Output() onGetNameNode = new EventEmitter<string>();
  @Output() onListHistory = new EventEmitter<any>();


  arrayColorUsed: Array<any> = ['#000000'];
  timestampLastClick = 0;
  formNode: FormGroup;
  loading = false;
  submitted = false;
  color: String;
  statusModal: number;
  optionMenu: any;
  modalRef: BsModalRef;
  modalRefNodeRoot: BsModalRef;
  modalRefDeleteNode: BsModalRef;
  nameNodeRoot: string;
  nodeSelected: any;
  nodeMiddle: any;
  modalAlert: any;
  valueRadio: any = 1;
  statusChildren = false;
  listHistoric: any = [];
  indexHistorySelected: any = null;
  position: any;

  @ViewChild('modalNode', { static: true })
  private modalNode: TemplateRef<any>;
  @ViewChild('modalNodeRoot', { static: true })
  private modalNodeRoot: TemplateRef<any>;
  @ViewChild('modalDeleteNode', { static: true })
  private modalDeleteNode: TemplateRef<any>;
  @ViewChild('alert', { static: true })
  private alert: TemplateRef<any>;


  elements: any = {
    nodes: [
      { data: { id: 'n', label: '' } },
    ]
  };

  cy = null;
  eh = null;
  config = {
    container: null,
    elements: this.elements,
    layout: {
      name: 'cose',
      animate: false,

    },
    maxZoom: 2.5,
    minZoom: 0.5,
    style: [
      {
        selector: 'node',
        style: {
          'shape': 'barrel',
          'label': 'data(id)',
          'background-color': 'black',
          'text-valign': 'center',
          'text-halign': 'center',
          'content': 'data(label)',
          'height': 20,
          'width': 20,
          'line-color': '#D3D3D3',
        }
      },
      {
        selector: '.eh-hover',
        style: {
          'background-color': '#D3D3D3',
          'line-color': '#D3D3D3',

        }
      },
      {
        selector: '.eh-source',
        style: {
          'border-width': 2,
          'border-color': '#D3D3D3',
        }
      },
      {
        selector: '.eh-target',
        style: {
          'border-width': 1,
          'border-color': '#D3D3D3',
        }
      },
      {
        selector: '.eh-preview, .eh-ghost-edge',
        style: {
          'background-color': '#D3D3D3',
          'line-color': '#D3D3D3',
          'target-arrow-color': '#D3D3D3',
          'source-arrow-color': '#D3D3D3'
        }
      },
      {
        selector: '.eh-handle',
        style: {
          'label': '',
          'background-color': '#D3D3D3',
          'width': 6,
          'height': 6,
          'shape': 'ellipse',
          'overlay-opacity': 0,
          'border-width': 12, // makes the handle easier to hit
          'border-opacity': 0
        }
      },
      {
        selector: '.eh-ghost',
        style: {
          'label': ''
        }
      },
      {
        selector: 'edge',
        style: {
          'target-arrow-shape': 'triangle',
          'curve-style': 'unbundled-bezier',
          'line-color': '#D3D3D3',
          'target-arrow-color': '#D3D3D3',
          'width': 2
        }
      },
      {
        selector: ':selected',
        style: {
          'border-width': 1,
          'border-color': 'black'
        }
      },
      {
        selector: 'edge[secondary="' + true + '"]',
        style: {
          'target-arrow-shape': 'triangle',
          'curve-style': 'unbundled-bezier',
          'line-color': '#D3D3D3',
          'target-arrow-color': '#D3D3D3',
          'width': 2
        }
      },
      {
        selector: 'edge[secondary="' + false + '"]',
        style: {
          'target-arrow-shape': 'triangle',
          'line-color': 'black',
          'target-arrow-color': 'black',
          'curve-style': 'straight',
          'width': 2,
        }
      }
    ]

  };

  constructor(private formBuilder: FormBuilder,
    private toolbarService: ToolbarService,
    private colorService: ColorService,
    private nodeService: NodeService,
    private mutualService: MutualService,
    private el: ElementRef,
    private modalService: BsModalService,
    private edgehandlesService: EdgehandlesService,
    private panzoomService: PanzoomService

  ) {
    toolbarService = this.toolbarService;
    colorService = this.colorService;
    nodeService = this.nodeService;
    mutualService = this.mutualService;
    panzoomService = this.panzoomService;
  }



  ngAfterViewInit() {
    if (this.data && this.cy) {
      this.loadData(this.data);
    }

  }

  async ngOnInit() {
    const that = this;
    this.config.container = this.el.nativeElement.firstElementChild;
    this.cy = cytoscape(this.config);
    this.cy.on('tap', 'node', function (event) {
      const timestampClick = event.timeStamp;
      const result = timestampClick - this.timestampLastClick;
      if (that.nodeAttach) {
        if (that.nodeAttach.data('id') !== event.target.data('id')) {
          const nodeSelected = that.nodeService.attachNode(event.target, that.nodeAttach, that);
          that.mutualService.refreshToolbarNode(nodeSelected, that);
          that.nodeAttach = null;
          that.onSelectNodeAttached.emit(that.nodeAttach);
        }
      }

      if (result < 500) {
        event.target.trigger('doubletap', event);
      }

      this.timestampLastClick = timestampClick;
    });

    this.cy.on('tap', 'edge', function (event) {
      const timestampClick = event.timeStamp;
      const result = timestampClick - this.timestampLastClick;

      if (result < 500) {
        event.target.trigger('doubletapEdge', event);
      }

      this.timestampLastClick = timestampClick;
    });


    this.cy.on('doubletap', function (event, originalTapEvent) {
      if (event.target.data('detached') === 'false') {
        that.nodeService.openModalUpdateNode(event.target, that);
      }

    });
    this.cy.on('doubletapEdge', 'edge', function (event) {
      if (event.target.data('secondary') === 'true') {
        that.cy.remove('edge[id="' + event.target.data('id') + '"]');

      }
    });
    this.cy.on('mouseout', 'node', function (event) {
      const node = event.target;
      that.toolbarService.hideToolbarNode(node);
    });
    this.cy.on('mouseover', 'node', function (event) {
      const node = event.target;
      that.toolbarService.showToolbarNode(node);
    });
    this.cy.ready(function (event) {
      if (that.data) {
        // charge le graph
        that.emitChange('load');

      } else {
        that.emitChange('create');
        that.toolbarService.hideToolbarNode(that.nodeService.getNodeById('n', that));
      }
    });
    this.cy.on('mousedown', 'node', function (event) {
      that.position = copy(event.target.position());
    });

    this.cy.on('mouseup', 'node', async (event) => {
      const position = event.target.position();
      if (that.position) {
        if (position.x > that.position.x || position.x < that.position.x
          || position.y > that.position.y || position.y < that.position.y) {
          that.emitChange('update');

        }
      }
    });
    const optionsMenu = {
      menuItems: [
        {
          id: 'add-node',
          content: 'Ajouter un noeud enfant',
          selector: 'node[detached="false"]',
          onClickFunction: (event) => {
            const node = event.target;
            this.nodeService.openModalAddNode(node, that);
          }
        },
        {
          id: 'add-node-inter',
          content: 'Ajouter un node intermÃ©diaire',
          selector: 'edge[secondary!="true"]',
          onClickFunction: (event) => {
            const edge = event.target;
            this.nodeService.addNodeMiddleSinceEdge(edge, this);
          }
        },
        {
          id: 'detach-node-since-edge',
          content: 'DÃ©tacher le node du lien ',
          selector: 'edge[secondary!="true"]',
          onClickFunction: (event) => {
            const edge = event.target;
            const node = this.nodeService.detachNodeSinceEdge(edge, this);
            this.mutualService.refreshToolbarNode(node, this);
            this.emitChange('update');
          }
        },
        {
          id: 'delete-edge-secondary',
          content: 'Supprimer le lien: dbClick',
          selector: 'edge[secondary="true"]',
          onClickFunction: (event) => {
            const edge = event.target;
            this.nodeService.deleteEdge(this, edge.data('id'));
            this.emitChange('update');
          }
        },
        {
          id: 'rename-node',
          content: 'Modifier',
          selector: 'node[detached="false"]',
          onClickFunction: (event) => {
            const node = event.target;
            this.nodeService.openModalUpdateNode(node, this);
          }
        },
        {
          id: 'collapse',
          content: 'Replier',
          selector: 'node[last!="true"][collapsed!="true"]',
          onClickFunction: (event) => {
            const node = event.target;
            this.toolbarService.collapseNode(node, this, this.color);
            this.mutualService.refreshToolbarNode(event.target, this);
          }
        },
        {
          id: 'expand',
          content: 'DÃ©plier',
          selector: 'node[last!="true"][collapsed!="false"]',
          onClickFunction: (event) => {
            const node = event.target;
            this.toolbarService.expandNode(node, this);
            this.mutualService.refreshToolbarNode(event.target, this);
          }
        },
        {
          id: 'remove-node',
          content: 'Supprimer',
          selector: 'node[id!="n"]',
          onClickFunction: (event) => {
            const node = event.target;
            this.openModalDeleteNode(node);
          }
        },
        {
          id: 'detach-node-edge',
          content: 'DÃ©tacher le node',
          selector: 'node[detached="false"][id!="n"]',
          onClickFunction: (event) => {
            this.nodeService.detachNode(event.target, this);
            this.mutualService.refreshToolbarNode(event.target, this);
            this.emitChange('update');
          }
        },
        {
          id: 'detach-node-edge',
          content: 'Atttacher le node',
          selector: 'node[detached="true"][id!="n"]',
          onClickFunction: (event) => {
            // this.openModalAlert() ;

            this.nodeAttach = event.target;
            this.onSelectNodeAttached.emit(this.nodeAttach);
            // const edge = event.target;
            // this.nodeService.addNodeMiddleSinceEdge(edge, this);
          }
        },

      ]
    };

    this.optionMenu = this.cy.contextMenus(optionsMenu);
    this.optionMenu.isActive();
    this.mutualService.addToolbarNode('n', this);

    this.cy.on('cxttapstart', 'node', function (event) {
      const node = event.target;
      if (!node.data('collapsed') && that.nodeService.getNodeConnected(node).length > 0) {
        that.optionMenu.hideMenuItem('expand-node');
        that.optionMenu.showMenuItem('collapse-node');
      }
      if (node.data('collapsed')) {

        that.optionMenu.hideMenuItem('collapse-node');
        that.optionMenu.showMenuItem('expand-node');
      }
      if (!node.data('collapsed') && that.nodeService.getNodeConnected(node).length === 0) {
        that.optionMenu.hideMenuItem('expand-node');
        that.optionMenu.hideMenuItem('collapse-node');
      }
      that.mutualService.refreshToolbarNode(node, that);
    });

    this.cy.on('ehcomplete', function () {
      that.emitChange('update');
    });


    function checkedColor(control: FormControl) {
      const color = control.value;
      if (that.arrayColorUsed.includes(color)) {
        return {
          validateColor: {
            valid: false
          }
        };
      } else {
        return null;
      }

    }
    // initialisation
    this.formNode = new FormGroup({
      id: new FormControl(null),
      status: new FormControl(null),
      name: new FormControl(null, [Validators.required, Validators.maxLength(40)]),
      description: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      color: new FormControl(this.colorService.checkedColor(that.arrayColorUsed), [Validators.required, checkedColor])
    });



    this.eh = this.cy.edgehandles(this.edgehandlesService.defaults);
    this.cy.panzoom(this.panzoomService.defaults);


    await this.renderGraph();

  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (typeof (changes.data.currentValue) === 'object' && this.cy) {
        this.loadData(changes.data.currentValue);
        this.listHistoric = [];
        this.indexHistorySelected = null;
        this.pushHistory(changes.data.currentValue);
      }
      if (changes.colorBackground && changes.colorBackground !== undefined) {
        this.loadColorBackground(changes.colorBackground.currentValue);
      }
      if (changes.nodeAttach) {
        this.nodeAttach = changes.nodeAttach.currentValue;
      }
    }
  }

  get f() {
    return this.formNode.controls;
  }
  openModal() {
    this.destroyPanzoom();
    this.modalRef = this.modalService.show(this.modalNode, { class: 'modal-lg', keyboard: false });
  }
  closeModal() {
    this.modalRef.hide();
    this.onCancelModal.emit(true);
    this.addPanzoom();
    this.formNode.reset();
  }
  openModalNodeRoot() {
    this.destroyPanzoom();
    this.modalRefNodeRoot = this.modalService.show(this.modalNodeRoot, { class: 'modal-sm' });
  }
  async openModalDeleteNode(node) {
    this.destroyPanzoom();
    this.nodeSelected = node;
    const listChild = await this.nodeService.getChildrenNode(node, this);
    if (listChild.length === 0 || node.data('detached') === 'true') {
      this.statusChildren = false;
      this.valueRadio = 1;
    } else {
      this.statusChildren = true;
    }
    this.modalRefDeleteNode = this.modalService.show(this.modalDeleteNode, {
      class: 'modal-lg',
      keyboard: false, ignoreBackdropClick: true
    });
  }

  closeModalNodeRoot() {
    this.modalRefNodeRoot.hide();
    this.emitChange('update');
    this.addPanzoom();
  }
  closeModalDeleteNode() {
    this.modalRefDeleteNode.hide();
    this.addPanzoom();
  }
  getWitdth(text) {

    const w = pixelWidth(text, {
      size: 12,
      font: 'Helvetica',
    });

    return Math.round(w);
  }
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid
    if (this.formNode.invalid) {
      return;
    }

    this.loading = true;

    const nodeId = this.formNode.value.id;
    const node = this.nodeService.getNodeById(nodeId, this);

    switch (this.statusModal.toString()) {
      case '0':
        this.addInformationNode(node);
        break;
      case '1':
        this.nodeService.updateInformationNode(node, this);
        break;
      case '2':
        this.addInformationNode(node);
        break;
      default:
        break;
    }
    this.submitted = false;
    this.loading = false;
    this.emitChange('update');
    this.formNode.get('status').setValue(this.statusModal);
    this.onSubmited.emit(this.formNode.value);
    this.closeModal();
  }
  addInformationNode(node) {
    const newNodeId = this.mutualService.addChildNode(node, this.formNode.value.name,
      this.formNode.value.color, this.formNode.value.description, this);
    this.onSelectIdNode.emit(node.data('id'));
    this.formNode.get('id').setValue(newNodeId);
  }
  renderGraph() {
    const options = {
      name: 'cose',
      animate: false,

    };

    const layout = this.cy.layout(options);


    layout.run();
    this.cy.nodes().noOverlap({ padding: 5 });


  }



  async emitChange(key: string) {
    await this.cleanMindmap();
    const json = this.cy.json();
    await this.onChange.emit({ status: key, value: json });
    this.history(key, json);

  }
  pushHistory(json) {
    const today = new Date();
    const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    const obj = {
      name: 'Sauvegarde de ' + time,
      json: json
    };
    this.listHistoric.push(obj);
    this.onListHistory.emit(this.listHistoric);
  }
  history(key, json) {
    if (key === 'update') {
      this.pushHistory(json);

      if (this.indexHistorySelected !== null) {
        const lastIndex = this.listHistoric.length - 1;
        if (lastIndex > this.indexHistorySelected) {
          let newListHistory = this.listHistoric.slice(this.indexHistorySelected, lastIndex + 1);
          newListHistory = newListHistory.reverse();
          this.listHistoric = this.listHistoric.concat(newListHistory);
        }
      }
      if (this.listHistoric.length > 11) {
        this.listHistoric.splice(0, 1);
      }
      this.indexHistorySelected = null;
    }
    if (key === 'load') {
      this.listHistoric = [];
      this.indexHistorySelected = null;
      this.pushHistory(json);
    }
  }

  async loadData(data: Object) {
    await this.cy.json(data);
    this.cy.nodes().noOverlap({ padding: 5 });
    await this.removeAllToolbar();
    await this.refreshAllToolbar();
    await this.hideAllToolbar();
  }

  loadColorBackground(color: string) {
    this.colorBackground = color;
  }
  removeNode() {
    let parent: any;
    const children = this.nodeService.getChildrenNode(this.nodeSelected, this);
    if (this.valueRadio === 1) {
      this.mutualService.removeNode(this);

    } else {
      parent = this.nodeService.getParentNode(this.nodeSelected, this);
      this.nodeService.deleteEdge(this, parent[0].data('id') + '-' + this.nodeSelected.data('id'));
      this.hideAllToolbar();

      this.nodeService.deleteNode(this, this.nodeSelected.data('id'));
      if (this.valueRadio === 2) {

        for (let child in children) {
          child = children[child];
          this.nodeService.detachNode(child, this);
        }
      }
      if (this.valueRadio === 3) {

        for (let child in children) {
          child = children[child];
          this.nodeService.attachNode(parent[0], child, this);
        }
      }
    }

    this.refreshAllToolbar();
    this.hideAllToolbar();
    this.valueRadio = 1;
    this.closeModalDeleteNode();
  }

  show() {
    this.cy.style().selector('edge[secondary="' + true + '"]').style({
      'curve-style': 'unbundled-bezier',
      'line-color': '#D3D3D3',
      'target-arrow-color': '#D3D3D3',
      'width': 2
    }).update();
  }
  hide(color: string) {
    if (this.cy.edges('[secondary="' + true + '"]').length > 0) {
      if (color === 'rgba(0, 0, 0, 0)') {
        color = 'white';
      }
      this.cy.style().selector('edge[secondary="' + true + '"]').style({
        'curve-style': 'unbundled-bezier',
        'line-color': color,
        'target-arrow-color': color,
        'width': 2
      }).update();
    }
  }
  highlightNode(arrayNodeId: Array<number>) {
    const that = this;
    for (const id of arrayNodeId) {
      this.cy.style().selector('node[id="' + id + '"]').style({
        'border-width': '1px black',
      }).update();
    }

    setTimeout(function () {
      that.notHighlightNode(arrayNodeId);
    }, 3000);

  }

  notHighlightNode(arrayNodeId: Array<number>) {
    for (const id of arrayNodeId) {
      this.cy.style().selector('node[id="' + id + '"]').style({
        'border-width': '0px',
      }).update();
    }
  }

  submitModalNodeRoot() {
    this.nodeService.saveNameNodeRoot(this.nameNodeRoot, this);
    this.closeModalNodeRoot();
  }

  resetMindmap() {
    this.ngOnInit();
  }

  hideAllToolbar() {
    const arrayIdNodes = this.nodeService.getAllKeyNode(this, 'id');
    for (const id of arrayIdNodes) {
      this.mutualService.refreshToolbarNode(this.nodeService.getNodeById(id, this), this);
      this.toolbarService.hideToolbarNode(this.nodeService.getNodeById(id, this));
    }
  }

  removeAllToolbar() {
    const arrayIdNodes = this.nodeService.getAllKeyNode(this, 'id');
    for (const id of arrayIdNodes) {
      this.toolbarService.removeToolbarNode(this.nodeService.getNodeById(id, this));
    }
  }

  refreshAllToolbar() {
    const arrayIdNodes = this.nodeService.getAllKeyNode(this, 'id');
    for (const id of arrayIdNodes) {
      this.mutualService.refreshToolbarNode(this.nodeService.getNodeById(id, this), this);
    }
  }


  disable() {
    this.eh.disable();
  }

  enable() {
    this.eh.enable();

  }

  cleanMindmap() {
    this.cy.nodes('.eh-handle').remove();
    this.cy.nodes('.eh-ghost-node').remove();
    this.cy.edges('.eh-ghost-edge').remove();
  }

  destroyPanzoom() {
    // this.cy.panzoom.destroy();
    this.cy.panzoom('destroy');

  }
  addPanzoom() {
    this.cy.panzoom(this.panzoomService.defaults);

  }
  getNameNode(nameNode: string) {
    this.onGetNameNode.emit(nameNode);
  }

  async  beforeHystory() {
    if (this.listHistoric.length > 0) {
      if (this.indexHistorySelected === null) {
        this.indexHistorySelected = this.listHistoric.length - 1;
        const json = this.listHistoric[this.indexHistorySelected]['json'];
        this.loadData(json);
        return json;
      } else {
        if (this.indexHistorySelected > 0) {
          const index = copy(this.indexHistorySelected - 1);
          if (this.listHistoric[index] !== undefined && index > -1) {
            this.indexHistorySelected = this.indexHistorySelected - 1;
            const json = this.listHistoric[this.indexHistorySelected]['json'];
            this.loadData(json);
            return json;
          }
        }
      }
    }
  }

  async afterHystory() {
    if (this.listHistoric.length > 0) {
      if (this.indexHistorySelected < 10 && this.indexHistorySelected != null && this.indexHistorySelected > -1) {
        const index = copy(this.indexHistorySelected + 1);
        if (this.listHistoric[index] !== undefined && index < 10) {
          this.indexHistorySelected++;
          const json = this.listHistoric[this.indexHistorySelected]['json'];
          this.loadData(json);
          return json;
        }
      }
    }
  }

  loadJsonHistoric(index) {
    this.indexHistorySelected = index;
    const json = this.listHistoric[this.indexHistorySelected]['json'];
    this.loadData(json);
    return json;
  }
  getListHistoric() {
    return this.listHistoric;
  }
}




